import { AccountCard } from "./AccountCard.js";
import { GoogleCalendarCard } from "./GoogleCalendarCard.js";
import { SettingsAnchor } from "./SettingsCard.js";
import { SyncCard } from "./SyncCard.js";

/** "Sync & accounts" — sign-in, multi-device sync, and Google Calendar. */
export function SyncSettings() {
  return (
    <div className="flex flex-col gap-6">
      <SettingsAnchor id="account"><AccountCard /></SettingsAnchor>
      <SettingsAnchor id="sync"><SyncCard /></SettingsAnchor>
      <SettingsAnchor id="google-calendar"><GoogleCalendarCard /></SettingsAnchor>
    </div>
  );
}
